export default [
	{
		path: 'inicio/minha-conta',
		component: () => import('@/pages/Inicio/MinhaConta/Pages/Index'),
		name: 'MinhaConta',
		meta: {
			path: '/inicio/minha-conta',
			pai: 'Início',
			title: 'siS - Minha Conta',
			navigation: [{
				pagina: 'Home',
				class: 'ace-icon fa fa-home home-icon',
				active: false,
				url: '/'
			},
			{
				pagina: 'Minha Conta',
				class: '',
				active: true,
				url: false
			}],
			noCache: true
		}
	}
]